import { useStore, selectActiveClip } from '../store'
import { computeBeats, hookScore, retentionCurve, autoHighlights } from '../lib/beats'

function fmt(t: number): string {
  const m = Math.floor(t / 60)
  const s = Math.floor(t % 60)
  return `${m}:${s.toString().padStart(2, '0')}`
}

/** GĐ7 — Story: beat map, Hook Doctor, retention, auto highlights. */
export function StoryPanel() {
  const clip = useStore(selectActiveClip)
  const seekTo = useStore((s) => s.seekTo)
  const trimActiveTo = useStore((s) => s.trimActiveTo)

  if (!clip) return null
  if (!clip.transcribed) {
    return (
      <div className="logopanel">
        <div className="logopanel-head">🎬 Story (beat map · hook · highlights)</div>
        <div className="muted small-note">Phiên âm clip để mở khóa phân tích câu chuyện.</div>
      </div>
    )
  }

  const beats = computeBeats(clip)
  const hook = hookScore(clip)
  const curve = retentionCurve(clip)
  const highlights = autoHighlights(clip)
  const t0 = beats[0]?.start ?? 0
  const t1 = beats[beats.length - 1]?.end ?? clip.duration
  const span = t1 - t0 || 1

  return (
    <div className="logopanel">
      <div className="logopanel-head">🎬 Story</div>

      {/* Beat map */}
      {beats.length > 0 && (
        <>
          <div className="muted small-note" style={{ margin: '0 0 4px' }}>Cấu trúc — bấm để tua</div>
          <div className="beatbar">
            {beats.map((b) => (
              <div
                key={b.label}
                className="beat"
                style={{ left: `${((b.start - t0) / span) * 100}%`, width: `${((b.end - b.start) / span) * 100}%`, background: b.color }}
                title={`${b.label} (${fmt(b.start)})`}
                onClick={() => seekTo(clip.id, b.start)}
              >
                {b.label}
              </div>
            ))}
          </div>
        </>
      )}

      {/* Hook Doctor */}
      <div className="hook">
        <div className="hook-score" style={{ borderColor: hook.score >= 70 ? 'var(--accent-2)' : 'var(--amber)' }}>
          {hook.score}
        </div>
        <div className="hook-body">
          <b>Hook Doctor</b>
          {hook.tips.map((t, i) => (
            <div key={i} className="muted" style={{ fontSize: 11 }}>• {t}</div>
          ))}
        </div>
      </div>

      {/* Retention curve */}
      {curve.length > 0 && (
        <div className="retention">
          <div className="muted small-note" style={{ margin: '0 0 4px' }}>Dự đoán giữ chân</div>
          <svg viewBox="0 0 100 30" preserveAspectRatio="none" className="retention-svg">
            <polyline
              points={curve.map((v, i) => `${(i / (curve.length - 1)) * 100},${30 - (v / 100) * 28}`).join(' ')}
              fill="none"
              stroke="var(--accent)"
              strokeWidth="1.5"
            />
          </svg>
        </div>
      )}

      {/* Auto highlights */}
      {highlights.length > 0 && (
        <div className="highlights">
          <div className="muted small-note" style={{ margin: '2px 0 4px' }}>✨ Đoạn đáng cắt short</div>
          {highlights.map((h, i) => (
            <div key={i} className="hl-row">
              <span className="hl-time" onClick={() => seekTo(clip.id, h.start)}>
                {fmt(h.start)}–{fmt(h.end)}
              </span>
              <span className="hl-prev" title={h.preview}>{h.preview}</span>
              <button className="mini" title="Cắt bản dựng còn đoạn này" onClick={() => trimActiveTo(h.end - h.start)}>
                ✂️
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
